module.exports = __webpack_public_path__ + "img/subscriptions-active.d01a52e.svg";